import type { Virtualizer } from '@tanstack/react-virtual';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import {
  getEventDateTimes,
  TimelineItem,
  type TimelineItemProps,
} from './item';
import { TimelineSectionHeader } from './section-header';
import { TimelineContainer } from './timeline-container';

dayjs.extend(LocalizedFormat);

export { getEventDateTimes };

export function getTimelineForPrinting(
  rows: (TimelineItemProps['event'] | string)[],
  rowVirtualizer: Virtualizer<HTMLDivElement, Element>,
  groupBy: 'week' | 'month',
) {
  return (
    <TimelineContainer
      sx={{
        contain: 'none',
        backgroundColor: 'transparent',
        p: 0,
        pt: 0,

        '& ul > div': {
          mb: 2,
        },
      }}
    >
      <ul
        style={{
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          padding: '16px 0',
          marginTop: 0,
        }}
      >
        {rows.map((row, index) => {
          if (typeof row === 'string') {
            return (
              <TimelineSectionHeader
                key={row}
                ref={rowVirtualizer.measureElement}
                groupBy={groupBy}
                headerValue={row}
                style={{
                  position: 'relative',
                }}
              />
            );
          }

          const itemHeight = rowVirtualizer.measurementsCache[index].size;
          const itemMarginBottom = 16;
          const halfDotHeight = 6;

          return (
            <TimelineItem
              data-index={index}
              key={JSON.stringify(row.id)}
              id={`timeline-item-${JSON.stringify(row.id)}`}
              event={row}
              groupBy={groupBy}
              style={{
                position: 'relative',
              }}
              role="row"
              itemHeight={itemHeight}
              additionalDotStyles={{
                transform: 'translateY(0px)',
                position: 'relative',
                margin: 0,
                marginTop: -12,
                top: -(itemHeight / 2 + itemMarginBottom - halfDotHeight),
              }}
            />
          );
        })}
        <div className="timeline" role="presentation">
          <div className="inner-timeline" />
        </div>
      </ul>
    </TimelineContainer>
  );
}
